class SeFeAnalytics {
    constructor(config) {
        this.eventQueue = []; // NOTE: full-size needs access to this to start up
        this.win = window; // use local property to override in tests, if needed
        // DEPRECATED - These are here for backward compatibility only. Don't add new methods
        // and don't modify these in any way that breaks the old API contract.
        this.pageView = (...data) => { this.push({ type: 'V1:pageView', data }); };
        this.seEvent = (...data) => { this.push({ type: 'V1:seEvent', data }); };
        this.viewProductDetails = (...data) => { this.push({ type: 'V1:viewProductDetails', data }); };
        this.logImpression = (...data) => { this.push({ type: 'V1:logImpression', data }); };
        this.addToCart = (...data) => { this.push({ type: 'V1:addToCart', data }); };
        this.removeFromCart = (...data) => { this.push({ type: 'V1:removeFromCart', data }); };
        this.checkoutStep = (...data) => { this.push({ type: 'V1:checkoutStep', data }); };
        this.purchaseCart = (...data) => { this.push({ type: 'V1:purchaseCart', data }); };
        // The child will be responsible for posting to parent...
        // ...and the message will NOT have a child or parent type.
        // The LISTENER (this function) will pick up any message...
        // ...and push to the queue.
        this.onMessage = (event) => {
            if (event.data.type !== 'SEAnalytics:trackingCall')
                return;
            this.eventQueue.push(event.data.eventData);
            this.processQueue();
        };
        this.win.addEventListener('message', this.onMessage);
        if (!this.legacyAnalytics)
            this.win.seAnalytics = this;
        this.initConfig(config);
        this.load();
    }
    get legacyAnalytics() {
        return !!this.win.seAnalytics && !this.win.seAnalytics.push;
    }
    // This is the primary API for the module
    push(...events) {
        events.forEach(event => {
            event.timestamp = event.timestamp || Date.now(); // force a timestamp
            this.eventQueue.push(event);
        });
        this.processQueue();
    }
    processQueue() {
        // noop - will be replace when full-size loads
    }
    // DEPRECATED - use the push interface instead (above)
    trackEvent(type, data = {}, timestamp = Date.now()) {
        this.push({ type, data, timestamp });
    }
    // PRIVATE METHODS
    // Queue the initial config event
    initConfig(config) {
        this.config = config;
        const { orgId, platProp, currentEnv, platformSubSec } = config;
        this.push({
            type: 'V1:config',
            data: { orgId, platProp, currentEnv, platformSubSec },
            timestamp: -Infinity // Ensure we process the config first
        });
    }
    // Load the fulsize script
    load() {
        if (this.config.platProp === 'test')
            return;
        const target = document.querySelector('script');
        const script = document.createElement('script');
        script.async = true;
        script.setAttribute('src', this.setScriptSrc);
        script.setAttribute('type', 'module');
        target.parentElement.insertBefore(script, target);
    }
    // Check environment for script source
    get setScriptSrc() {
        const env = this.config.currentEnv.toLowerCase();
        if (env === 'staging' || env === 'stage' || env === 'dev' || env === 'development') {
            return 'https://se-fe-analytics.ui.sestage.us/se-analytics-core/main.js';
        }
        else {
            // Default to prod source to avoid releasing unfinished changes to other environments
            return 'https://se-fe-analytics.ui.sportngin.com/se-analytics-core/main.js';
        }
    }
}
// DEPRECATED - we expose these methods for backward compatibility (do not add more)
SeFeAnalytics.LEGACY_METHODS = [
    'pageView',
    'seEvent',
    'viewProductDetails',
    'logImpression',
    'addToCart',
    'removeFromCart',
    'checkoutStep',
    'purchaseCart'
];

/**
 * Generated bundle index. Do not edit.
 */

export { SeFeAnalytics };

